import React from "react";
import PdfDocumentTable from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import minorityConcentratedDistrictsPdf from "../../../../assets/tenders/resource/Minority_Concentrated_Districts_MCD-Distirictpdf-9708bdb5b703097416347f17d5eb94a4.pdf";

const minorityConcentratedDistrictsDocuments = [
  {
    serial: 1,
    title: "Minority Concentrated Districts",
    fileName:
      "Minority_Concentrated_Districts_MCD-Distirictpdf-9708bdb5b703097416347f17d5eb94a4.pdf",
    href: minorityConcentratedDistrictsPdf,
  },
];

const MinorityConcentratedDistricts = () => (
  <section className="min-w-0 flex-1">
    <h2 className="mb-3 text-[18px] font-bold text-[#005856]">
      Minority Concentrated Districts
    </h2>
    <PdfDocumentTable
      documents={minorityConcentratedDistrictsDocuments}
      minWidth="680px"
    />
  </section>
);

export default MinorityConcentratedDistricts;